export enum DataFields {
    carType = "carType",
    carDescriptionMake = "carDescriptionMake",
    carDescriptionModel = "carDescriptionModel",
    carDescriptionFuel = "carDescriptionFuel",
    carDescriptionPower = "carDescriptionPower",
    carDescriptionCatalogValue = "carDescriptionCatalogValue",
    carDescriptionDateRegistration = "carDescriptionDateRegistration",
    carDescriptionDatePurchased = "carDescriptionDatePurchased",
    carDescriptionInvoiceValue = "carDescriptionInvoiceValue",
    carDescriptionVehicleType = "carDescriptionVehicleType",
    driverInformationBirthday = "driverInformationBirthday",
    driverInformationCity = "driverInformationCity",
    driverInformationPostalCode = "driverInformationPostalCode",
    driverInformationStreet = "driverInformationStreet",
    driverInformationNumber = "driverInformationNumber",
    driverInformationLetterBox = "driverInformationLetterBox",
    driverHistory_License = "driverHistory_License",
    driverHistory_Insurance = "driverHistory_Insurance",
    driverHistory_Accidents = "driverHistory_Accidents",
    carDetailsMileage = "carDetailsMileage",
    carDetailsSecurityOptions = "carDetailsSecurityOptions",
    totalPrice = "totalPrice",
    insuranceChoice = "insuranceChoice",
    brokerData = "brokerData",
    yourInformationFirstName = "yourInformationFirstName",
    yourInformationLastName = "yourInformationLastName",
    yourInformationEmail = "yourInformationEmail",
    yourInformationPhone = "yourInformationPhone",
    yourInformationQuestion = "yourInformationQuestion",
    yourInformationConsent = "yourInformationConsent",
    weTakeCareActivated = "weTakeCareActivated",
    weTakeCareStepout = "weTakeCareStepout",
    weTakeCareReason = "weTakeCareReason",
    flowFinished = "flowFinished",
    thankYouData = "thankYouData",
}

export enum PageNames {
    Welcome = "Welcome",
    CarType = "CarType",
    CarDescription = "CarDescription",
    CarDetails = "CarDetails",
    DriverInformation = "DriverInformation",
    DriverHistory = "DriverHistory",
    InsuranceChoice = "InsuranceChoice",
    AdditionalCovers = "AdditionalCovers",
    BrokerSearch = "BrokerSearch",
    YourInformation = "YourInformation",
    ThankYou = "ThankYou",
    TechnicalDifficulties = "TechnicalDifficulties",
}

export enum GetTariffParameterObjectCarType {
    NewCar = "New",
    CurrentCar = "Current",
    SecondHandCar = "SecondHand",
}

export enum InsuranceType {
    NoOmnium = "civil.liability",
    BigOmnium = "large.omnium",
    SmallOmnium = "small.omnium",
}

export enum CarLeadRequestBodyLeadType {
    QuoteLead = "QuoteLead",
    WtcMin = "WtcMin",
}

export enum CoverType {
    LegalAssistance = "legal.assistance",
    Assistance = "extended.assistance",
    Driver = "driver",
}

export enum VehicleType {
    PersonalCar = "PersonalCar",
}
